import { IconButton, InputAdornment, Tooltip } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Close from '@material-ui/icons/Close';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import { useFormikContext } from 'formik';
import { withSnackbar } from 'notistack';
import propTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import InputWithFormik from './InputWithFormik';

const useStyles = makeStyles(() => ({
  filename: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    width: '100%',
    display: 'inline-block',
    cursor: 'pointer'
  }
}));

const InputComponent = ({ inputRef, ...other }) => <div {...other} />;

const InputFileWithFormik = ({ name, ...mainProps }) => {
  const { enqueueSnackbar, onClick, ...props } = mainProps;
  delete props.closeSnackbar;
  delete props.onPresentSnackbar;

  const { values, setFieldValue, setFieldTouched } = useFormikContext();
  const [filename, setFilename] = useState();
  const [recuperado, setRecuperado] = useState();
  const fileInput = React.createRef();
  const theme = useTheme();
  const classes = useStyles(theme);

  const value = values[name];

  const onFileSelected = ({ target }) => {
    if (target.files.length > 0) {
      setRecuperado(true);
      const { name: selectedFileName } = target.files[0];
      setFilename(selectedFileName);
      setFieldValue(name, target.files);
    }
  };

  const onFileDeleted = event => {
    event.preventDefault();
    event.stopPropagation();
    fileInput.current.value = null;
    setFieldValue(name, []);
    setFilename('');
    setFieldTouched(name, true);
  };

  const innerProps = {
    name,
    onChange: onFileSelected
  };

  const inputProps = {
    onClick: () => {
      if (onClick) {
        onClick();
      } else {
        fileInput.current.click();
      }
    },
    style: { cursor: 'pointer' },
    children: (
      <>
        <input
          accept="application/pdf"
          style={{ display: 'none' }}
          id={name}
          type="file"
          onClick={() => {
            if (onClick) {
              onClick();
            } else {
              setFieldTouched(name, true);
            }
          }}
          ref={fileInput}
        />
        {filename && (
          <Tooltip title={filename} arrow placement="bottom-start">
            <label className={classes.filename}>{filename}</label>
          </Tooltip>
        )}
      </>
    )
  };
  const textFieldProps = { ...innerProps, ...props, inputProps };

  useEffect(
    () => {
      if (value && value.length > 0 && value[0].name && !recuperado) {
        const { name: selectedFileName } = value[0];
        setFilename(selectedFileName);
        fileInput.current.files = value;
        setRecuperado(true);
      }
    },
    [fileInput, value, recuperado]
  );

  return (
    <InputWithFormik
      InputProps={{
        inputComponent: InputComponent,
        startAdornment: (
          <InputAdornment position="start">
            <IconButton onClick={() => fileInput.current.click()}>
              <PictureAsPdfIcon />
            </IconButton>
          </InputAdornment>
        ),
        endAdornment: filename && (
          <InputAdornment position="end">
            <IconButton
              onClick={onFileDeleted}
              style={{
                display: filename ? 'block' : 'none'
              }}
            >
              <Close />
            </IconButton>
          </InputAdornment>
        )
      }}
      {...textFieldProps}
    />
  );
};

InputFileWithFormik.propTypes = {
  name: propTypes.string.isRequired,
  label: propTypes.string
};

export default withSnackbar(InputFileWithFormik);
